export default "__VITE_ASSET__BRtARw27__"